import { useQuery } from '../../hooks/use-query';
import { InSync } from '../../types/in-sync';
import React from 'react';

type Props = {
  path: string;
};

export const NotInSync = (props: Props): JSX.Element => {
  const inSync = useQuery<InSync>({ path: `/${props.path}/in-sync` });
  return inSync.data?.inSync === false ? (
    <div className="not-in-sync-container">
      <span className="not-in-sync">Not in sync</span>
    </div>) : <></>;
};
